<template>
    <div class="users">
      <div class="users-inner">

        <admin-sidebar></admin-sidebar>

        <div class="table">

          <div class="table-header">
            <div class="table-title">
              {{tableData.length + ' ' + (tableData.length === 1 ? 'user' : 'users')}}
            </div>
            <div class="table-header-actions">
              <div v-if="this.$hasRole(['admin'])" class="add-user mobile-hide">
                <a @click.prevent="editUser(null)" :class="{'disabled': this.multipleSelection.length !== 1}">edit user</a>
              </div>
              <div v-if="this.$hasRole(['admin'])" class="add-user mobile-hide">
                <a @click.prevent="removeUser(null)" :class="{'disabled': this.multipleSelection.length === 0}">remove user</a>
              </div>
              <div v-if="this.$hasRole(['admin'])" class="add-user mobile-hide">
                <a @click.prevent="addNewUser" class="button">add user</a>
              </div>
            </div>
          </div>

          <div class="table-list">
            <div class="table-list-inner">

              <el-table ref="multipleTable"
                        :data="tableData"
                        style="width: 100%"
                        @selection-change="handleSelectionChange"
                        v-loading="loading">

                <el-table-column prop="first_name" label="first name" min-width="180" sortable></el-table-column>

                <el-table-column prop="last_name" label="last name" min-width="180" sortable></el-table-column>

                <el-table-column prop="email" label="email" min-width="180" sortable></el-table-column>

                <el-table-column prop="role" label="role" width="180" sortable></el-table-column>

                <el-table-column prop="department.name" label="department" width="180" sortable></el-table-column>

                <el-table-column v-if="this.$hasRole(['admin'])" type="selection" header-align="right" align="right" width="180"></el-table-column>
              </el-table>

            </div>
          </div>

        </div>

        <div class="table-mobile" v-loading="loading">
          <div class="table-mobile-header">
            <div>{{tableData.length + ' ' + (tableData.length === 1 ? 'user' : 'users')}}</div>
            <div v-if="this.$hasRole(['admin'])" class="add-user">
              <a @click.prevent="addNewUser" class="button">add user</a>
            </div>
          </div>
          <div class="table-mobile-items">
            <div class="table-mobile-items-item" v-for="item in tableData" :key="item.id">
              <div class="table-mobile-items-item-left">
                <div class="table-mobile-items-item-left-upper">
                  <span>{{item.first_name + ' ' + item.last_name}}</span> <br/>
                  {{item.email}}
                </div>
                <div class="table-mobile-items-item-left-lower">
                  <span>role:</span> {{item.role.join(', ')}} <br/>
                  <span>department:</span> {{item.department ? item.department['name'] : ''}} <br/>
                </div>
              </div>
              <div class="table-mobile-items-item-right">
                <a @click.prevent="editUser(item)" class="button">edit</a>
                <a @click.prevent="removeUser(item)" class="button">remove</a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
</template>

<script>
import { HTTP } from '@/services/api'
import { EventBus } from '@/services/eventbus'
import AdminSidebar from '@/views/Private/Components/AdminSidebar'

export default {
  name: 'Users',
  components: { AdminSidebar },
  data () {
    return {
      loading: false,
      tableData: [],
      multipleSelection: []
    }
  },
  metaInfo () {
    return {
      title: 'Users'
    }
  },
  created () {
    EventBus.$on('reload-users', () => this.loadUsers())
  },
  beforeDestroy () {
    EventBus.$off('reload-users', true)
  },
  mounted () {
    this.loadUsers()
  },
  methods: {
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      EventBus.$emit('user-multiple-selection', this.multipleSelection)
    },
    loadUsers () {
      this.loading = true
      HTTP({
        method: 'GET',
        url: '/api/v1/users/',
        crossdomain: true
      })
        .then(response => {
          this.loading = false
          if (response.data.data) {
            this.tableData = response.data.data
          }
        })
        .catch(error => {
          this.loading = false
          this.$notify({
            // title: 'Error',
            message: error.response.data ? error.response.data.error.message : 'Error occured. Please try later',
            type: 'error',
            position: 'bottom-right',
            duration: 1750
          })
        })
    },
    addNewUser () {
      EventBus.$emit('open-modal', {
        type: 'user-add',
        data: {},
        header: true
      })
    },
    editUser (user = null) {
      if (user !== null) {
        this.multipleSelection = []
        this.multipleSelection[0] = user
      }
      if (this.multipleSelection.length === 0) {
        this.$notify({
          message: 'Please select user',
          type: 'error',
          position: 'bottom-right',
          duration: 1750
        })
        return
      }
      if (this.multipleSelection.length > 1) {
        return
      }
      EventBus.$emit('open-modal', {
        type: 'user-add',
        data: {
          user: this.multipleSelection[0]
        },
        header: true
      })
    },
    removeUser (user = null) {
      if (user !== null) {
        this.multipleSelection = []
        this.multipleSelection[0] = user
      }
      if (this.multipleSelection.length === 0) {
        this.$notify({
          message: 'Please select user/s',
          type: 'error',
          position: 'bottom-right',
          duration: 1750
        })
        return
      }
      let usersId = []
      let usersEmail = []
      Object.keys(this.multipleSelection).forEach(key => {
        usersId.push(this.multipleSelection[key].id)
        usersEmail.push(this.multipleSelection[key].email)
      })
      if (usersId.length > 0) {
        EventBus.$emit('open-modal', {
          type: 'user-remove',
          header: false,
          data: {
            usersId: usersId,
            usersEmail: usersEmail
          }
        })
      }
    }
  }
}
</script>
